import Helper from "./Helper";
import Swiper from "./swiper";

class Slider {
  constructor(config = {}) {
    const { } = config;

    this.sliders = document.querySelectorAll('.ns-keyfigures-4-col');
    this.swiperInstance = null;
    this.initSwiper(config);
  }

  initSwiper(config) {
    this.swiperInstance = new Swiper('.swiper', {
      slideClass: 'swiper-slide',
      resistance: true,
      resistanceRatio: 0,
      spaceBetween: 24,
      slidesPerView: 'auto',

      scrollbar: {
        el: '.swiper-scrollbar',
        snapOnRelease: true,
      },
    });
  }
}


export default Slider;
